/**
 * TagListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Pagination,
} from 'components';
import { Button, DatePicker, Input, Select } from 'antd';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';

const TagListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedTags, setSelectedTags] = useState([]);

  /* ===== VARIABLE ===== */
  let tags = [];
  for (let i = 0; i < 100; i++) {
    tags.push(`태그 ${i + 1}`);
  }

  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    tag: {
      border: '1px solid #70737C',
      borderColor: 'rgba(112, 115, 124, 0.2)',
      background: 'transparent',
      color: 'var(--black-color)',
      fontWeight: 400,
      borderRadius: 4,
      padding: '2px 10px',
      display: 'inline-block',
      margin: '0px 4px 4px 0px',
      cursor: 'pointer',
    },
  };

  const formItem = [
    {
      label: '노출여부',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: '노출됨', value: '노출됨' },
                { label: '노출안됨', value: '노출안됨' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '등록일자',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '태그 명',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="태그 명을 입력해주세요"
                style={{ ...styles.form.input.large }}
              />
              <div>
                {selectedTags.map((_item, _index) => (
                  <span
                    style={{
                      ...styles.tag,
                    }}
                    onClick={() =>
                      setSelectedTags((prev) =>
                        prev.includes(_item)
                          ? prev.filter((item) => item !== _item)
                          : [...prev, _item]
                      )
                    }
                  >
                    #{_item}
                  </span>
                ))}
              </div>
            </>
          ),
        },
      ],
    },
    {
      label: '',
      form: [
        {
          input: (
            <div
              style={{
                width: '100%',
                border: '1px solid #70737C',
                borderColor: 'rgba(112, 115, 124, 0.2)',
                padding: '10px 15px',
                height: 168,
                overflow: 'auto',
                borderRadius: 4,
              }}
            >
              {tags.map((_item, _index) => (
                <span
                  style={{
                    ...styles.tag,
                    borderColor: selectedTags.includes(_item)
                      ? 'var(--primary-color)'
                      : 'rgba(112, 115, 124, 0.2)',
                    background: selectedTags.includes(_item)
                      ? 'var(--primary-color)'
                      : 'transparent',
                    color: selectedTags.includes(_item)
                      ? '#FFFFFF'
                      : 'var(--black-color)',
                    fontWeight: selectedTags.includes(_item) ? 600 : 400,
                  }}
                  onClick={() =>
                    setSelectedTags((prev) =>
                      prev.includes(_item)
                        ? prev.filter((item) => item !== _item)
                        : [...prev, _item]
                    )
                  }
                >
                  #{_item}
                </span>
              ))}
            </div>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 10; i++) {
    newData.push({
      태그번호: '000000',
      태그명: '태그 명',
      등록일: new Date(),
      노출여부: i % 2 === 0 ? 'N' : 'Y',
      상품수: 123,
    });
  }

  let newData2 = [];
  for (let i = 0; i < 10; i++) {
    newData2.push({
      상품번호: '000000',
      상품명: '[케냐] 원두 100g',
      등록된태그: ['태그 명', '태그 명'],
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>태그 목록</Title>

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ minWidth: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Row gutter={[10, 10]}>
            <Col x={13}>
              <Content
                maxWidth={'100%'}
                borderRadius={4}
                padding={20}
                style={{ height: '100%' }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
                  검색 결과 총 <span>0</span>건
                </h4>
                <Table
                  data={newData}
                  columns={[
                    {
                      title: '태그 번호',
                      key: '태그번호',
                    },
                    {
                      title: '태그 명',
                      key: '태그명',
                      render: (item) => (
                        <span style={{ ...styles.tag }}>#{item}</span>
                      ),
                    },
                    {
                      title: '등록일',
                      key: '등록일',
                      render: (item) =>
                        moment(item).format('YYYY-MM-DD HH:mm:ss'),
                    },
                    {
                      title: '표시여부',
                      key: '표시여부',
                    },
                    {
                      title: '상품 수',
                      key: '상품수',
                      render: (item) => stringToMoneyFormat(item),
                    },
                    {
                      title: '비고',
                      key: '비고',
                      render: () => (
                        <>
                          <Button
                            size="small"
                            style={{
                              borderColor: 'var(--primary-color)',
                              color: 'var(--primary-color)',
                              marginRight: 4,
                            }}
                          >
                            수정
                          </Button>
                          <Button
                            size="small"
                            style={{ borderColor: '#EE4700', color: '#EE4700' }}
                          >
                            삭제
                          </Button>
                        </>
                      ),
                    },
                  ]}
                />
                <Pagination total={40} style={{ marginTop: 20 }} />
              </Content>
            </Col>
            <Col x={11}>
              <Content
                maxWidth={'100%'}
                borderRadius={4}
                padding={20}
                style={{ height: '100%' }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
                  검색 결과 총 <span>0</span>건
                </h4>
                <Table
                  data={newData2}
                  columns={[
                    {
                      title: '상품 번호',
                      key: '상품번호',
                    },
                    {
                      title: '상품명',
                      key: '상품명',
                      render: (item) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                    {
                      title: '등록 된 태그',
                      key: '등록된태그',
                      render: (item) =>
                        item.map((i) => (
                          <span style={{ ...styles.tag }}>#{i}</span>
                        )),
                    },
                    {
                      title: '비고',
                      key: '비고',
                      render: () => (
                        <>
                          <Button
                            size="small"
                            style={{
                              borderColor: 'var(--primary-color)',
                              color: 'var(--primary-color)',
                              marginRight: 4,
                            }}
                          >
                            수정
                          </Button>
                          <Button
                            size="small"
                            style={{ borderColor: '#EE4700', color: '#EE4700' }}
                          >
                            삭제
                          </Button>
                        </>
                      ),
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default TagListPresenter;
